export default __webpack_public_path__ + "static/media/step02.a5ff83d6.png";